import { DISPLAY_STATUS_STYLES } from "../constants";

export function getDisplayStatusStyle(displayStatus?: string | null): string {
  if (!displayStatus) return "bg-muted text-muted-foreground";
  return (
    DISPLAY_STATUS_STYLES[displayStatus] ?? "bg-muted text-muted-foreground"
  );
}
